import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { isChunkLoadError, reloadOnceOnChunkError } from './lib/appUpdate'

window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    reloadOnceOnChunkError()
  }
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
